export default function CtaBand() {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20wide%20watermelon%20field%20at%20sunset%20with%20floating%20chat%20bubbles%20and%20sparkles%2C%20deep%20green%20and%20warm%20cream%20tones%2C%20playful%20community%20theme%2C%20soft%20and%20welcoming%2C%20no%20text&width=1600&height=560&seq=cta-melon-01&orientation=landscape"
          alt="呱呱吃瓜投稿吃瓜横幅背景"
          className="absolute inset-0 h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-900/85 to-primary-700/60"></div>
      </div>
      <div className="relative mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="flex flex-col items-start gap-6 md:flex-row md:items-center md:justify-between">
          <div className="max-w-2xl">
            <p className="text-sm font-semibold text-secondary-200">投稿吃瓜 · 让更多人一起笑</p>
            <h3 className="mt-2 font-heading text-3xl text-background-50 md:text-4xl">
              评论区看到了神级名场面？投稿上来，分分钟登榜
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-background-100 md:text-base">
              把你刷到的高赞神回复、名场面或弹幕梗发给我们，审核通过后按频道收录并署上你的昵称。
            </p>
          </div>
          <a
            href="#contact"
            className="shrink-0 whitespace-nowrap rounded-full bg-secondary-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-500"
          >
            我要投稿吃瓜
          </a>
        </div>
      </div>
    </section>
  );
}